import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@components/core/select'

import { useDispatch } from '@store/index'
import { updateColumn } from '@store/slices/component/table-config'

import { ITableColumn, NumberFormat, isCellDataTypeNumber } from '../../types/table-builder-types'

export const Formatting = ({ item: column }: { item: ITableColumn }) => {
  const dispatch = useDispatch()
  const disabled = !isCellDataTypeNumber(column.cellDataType) || column.hide
  const value = column.customData?.numberFormat || NumberFormat.NONE

  return (
    <Select
      disabled={disabled}
      value={value}
      onValueChange={(value) =>
        dispatch(
          updateColumn({
            field: column.field,
            customData: { ...column.customData, numberFormat: value as NumberFormat }
          })
        )
      }
    >
      <SelectTrigger>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={NumberFormat.NONE}>None</SelectItem>
        <SelectItem value={NumberFormat.AMOUNT}>Amount</SelectItem>
        <SelectItem value={NumberFormat.PERCENTAGE}>Percentage</SelectItem>
      </SelectContent>
    </Select>
  )
}
